export const convertToSelect = (
  items: Array<any>,
  labelStr: string,
  valueStr: string,
) => {
  const arrayMod: Array<any> = [];
  items.forEach((item: any) => {
    arrayMod.push({
      label: item[labelStr],
      value: item[valueStr],
      year: item[labelStr].split(' ')[1],
      ...item,
    });
  });
  return arrayMod;
};
export const convertToSelectCombine = (
  items: Array<any>,
  labelStr1: string,
  labelStr2: string,
  valueStr: string,
) => {
  const arrayMod: Array<any> = [];
  items.forEach((item: any) => {
    arrayMod.push({
      label: `${item[labelStr1]}  ${item[labelStr2]}`,
      value: item[valueStr],
      ...item,
    });
  });
  return arrayMod;
};
export default convertToSelect;
